(() => {
  if (window.__dwSectionsLoaded) return;
  window.__dwSectionsLoaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class DwCountUp extends HTMLElement {
    connectedCallback() {
      const raw = this.textContent.trim();
      const match = raw.match(/^(\D*)([\d.,]+)(.*)$/s);
      if (!match || reducedMotion) return;
      const [, prefix, numText, suffix] = match;
      const decimals = (numText.split('.')[1] || '').length;
      const target = parseFloat(numText.replace(/,/g, ''));
      if (!isFinite(target)) return;

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        observer.disconnect();
        const start = performance.now();
        const duration = 1200;
        const tick = (now) => {
          const t = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - t, 3);
          this.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
          if (t < 1) requestAnimationFrame(tick);
          else this.textContent = raw;
        };
        requestAnimationFrame(tick);
      }, { threshold: 0.4 });
      observer.observe(this);
    }
  }

  class DwCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-dw-track]');
      this.prev = this.querySelector('[data-dw-prev]');
      this.next = this.querySelector('[data-dw-next]');
      if (!this.track) return;
      const loop = this.dataset.loop === 'true';

      const step = () => {
        const card = this.track.firstElementChild;
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };
      const atStart = () => this.track.scrollLeft <= 2;
      const atEnd = () => this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      const update = () => {
        if (loop) return;
        if (this.prev) this.prev.disabled = atStart();
        if (this.next) this.next.disabled = atEnd();
      };

      this.prev?.addEventListener('click', () => {
        if (loop && atStart()) this.track.scrollTo({ left: this.track.scrollWidth });
        else this.track.scrollBy({ left: -step() });
      });
      this.next?.addEventListener('click', () => {
        if (loop && atEnd()) this.track.scrollTo({ left: 0 });
        else this.track.scrollBy({ left: step() });
      });
      this.track.addEventListener('scroll', update, { passive: true });
      update();
    }
  }

  class DwAutoplayVideo extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      if (reducedMotion) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) video.play().catch(() => {});
          else video.pause();
        });
      }, { threshold: 0.25 });
      observer.observe(this);
    }
  }

  if (!customElements.get('dw-count-up')) customElements.define('dw-count-up', DwCountUp);
  if (!customElements.get('dw-carousel')) customElements.define('dw-carousel', DwCarousel);
  if (!customElements.get('dw-autoplay-video')) customElements.define('dw-autoplay-video', DwAutoplayVideo);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-dw-scroll-product]');
    if (!trigger) return;
    const target = document.querySelector('product-info, .product');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  });
})();
